import * as yup from 'yup';

import { ObjectTypeBase } from '../../types/baseTypes/ObjectTypeBase';
import { PropertiesInterface } from '../../types/properties/Property';
import { TypeContextEnum } from '../../types/properties/TypeContextEnum';
import Types from '../Types';
import { TYPE_GROUP_LANE } from '../constants';
import createShapeFromProperties from '../createShapeFromProperties';

const properties: PropertiesInterface = {
  _id: {
    type: 'UUID',
    validators: [
      {
        name: 'Required',
        value: true,
      },
    ],
  },
};

/**
 * @deprecated This class is deprecated and should not be used in new code.
 * Use SectionType from application-types instead.
 */
export class SectionType extends ObjectTypeBase {
  group = TYPE_GROUP_LANE;

  name = 'Section';

  friendlyName = 'Section';

  contexts = [TypeContextEnum.Block];

  superUserOnly = false;

  get example() {
    return {
      _id: '03SA53cjUgmXIdZp9VOi7e',
    };
  }

  get default(): any {
    return {
      _id: null,
    };
  }

  buildSchema() {
    return yup
      .object()
      .nullable()
      .default(null)
      .shape(createShapeFromProperties(properties));
  }

  properties = properties;
}

/**
 * @deprecated This constant is deprecated and should not be used in new code.
 * Use Section from application-types instead.
 */
const definition = new SectionType();

Types.addBaseType(definition);
export default definition;
